<ifc-app-scroll-container [widgetsWithTopHeader]="true">
  <div class="layout margin flex-std"
       [@routerTransition]="'fly'">
    <ifb-panel>
      <ifb-card>
        <ifc-simple-horizontal-list-widget [title]="data.offer.productName"
                                           [listItems]="productListData">
        </ifc-simple-horizontal-list-widget>
      </ifb-card>
    </ifb-panel>
  </div>
</ifc-app-scroll-container>
